import { useState, useEffect } from "react";
import { awsService } from "@/services/api/awsService";

export const useQuickSightAWSAccounts= () => {
  const [embedUrl, setEmbedUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchEmbedUrl = async () => {
    const dashboard_id = import.meta.env.VITE_QUICKSIGHT_DASHBOARD_ID_AWS_ACC;
    if (!dashboard_id) return;
    
    try {
      setLoading(true);
      setError(null);
      const response = await awsService.getQuickSightEmbedUrl(dashboard_id);
      setEmbedUrl(response.data.embedUrl);
    } catch (err) {
      setError(err.message || "Error loading QuickSight dashboard");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEmbedUrl();
  }, []);

  return {
    embedUrl,
    loading,
    error,
    refetch: fetchEmbedUrl
  };
};